import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Toolbar } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(0, 4),
        height: 56,
        minHeight: 56,
        borderBottom: `1px solid ${theme.palette.generalUi.borders}`,
        backgroundColor: theme.palette.generalUi.background,
    },
    title: {
        flexGrow: 1,
        padding: 0,
        fontSize: 24,
    },
    appbarContainer: {
        top: 0,
        position: "sticky",
        width: "100%",
    },
}));

const AnalyticsChartsTopbar = (props) => {
    const classes = useStyles(props);
    //const theme = useTheme();
    const { children, title } = props;

    return (
        <>
            <div>
                <Toolbar className={classes.root}>
                    <Typography variant="h3" className={classes.title}>
                        {title}
                    </Typography>
                    {children}
                </Toolbar>
            </div>
        </>
    );
};

export default AnalyticsChartsTopbar;
